var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.seriesList && _vm.seriesList.length
    ? _c(
        "ul",
        { staticClass: "sListWrapper" },
        _vm._l(_vm.seriesList, function (s, s_idx) {
          return _c("li", { key: s_idx, staticClass: "sListElement" }, [
            _c("a", { attrs: { href: _vm.getSeriesLink(s) } }, [
              _c("div", [_vm._v(_vm._s(s.series_name))]),
            ]),
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }